var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMonitor = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 23,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.3125 17.25L18.6875 17.25C19.4814 17.25 20.125 16.6064 20.125 15.8125V5.75C20.125 4.95609 19.4814 4.3125 18.6875 4.3125L4.3125 4.3125C3.51859 4.3125 2.875 4.95609 2.875 5.75V15.8125C2.875 16.6064 3.51859 17.25 4.3125 17.25Z",
  stroke: "#009579",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.375 20.125H8.625",
  stroke: "#009579",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.875 13.6562H20.125",
  stroke: "#009579",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 17.25V20.125",
  stroke: "#009579",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgMonitor as ReactComponent };
export default __webpack_public_path__ + "images/monitor.svg";